import { readFile } from 'node:fs/promises';
import { basename, join, relative } from 'node:path';

const IMPORTANT_NAMES = new Set([
  'README.md',
  'package.json',
  'tsconfig.json',
  'pnpm-workspace.yaml',
  'turbo.json',
  'vite.config.ts',
  'vite.config.js',
  'next.config.js',
  'next.config.mjs',
  'Cargo.toml',
  'pyproject.toml',
  'go.mod',
]);

const IMPORTANT_PREFIXES = ['src/index.', 'src/main.', 'src/app.', 'apps/dev-cli/src/index.'];
const SECRET_PATTERNS = [
  /^\.env(\..*)?$/i,
  /\.pem$/i,
  /\.key$/i,
  /(^|[/\\])id_rsa$/i,
  /(^|[/\\])id_dsa$/i,
];

export function isSecretPath(path: string): boolean {
  const name = basename(path);
  return SECRET_PATTERNS.some((pattern) => pattern.test(name) || pattern.test(path));
}

export function isImportantPath(path: string): boolean {
  const normalized = path.replace(/\\/g, '/');
  return IMPORTANT_NAMES.has(basename(normalized)) ||
    IMPORTANT_PREFIXES.some((prefix) => normalized.startsWith(prefix));
}

export async function readImportantFiles(
  workspaceRoot: string,
  files: readonly string[],
  maxCharsPerFile = 2500,
): Promise<Array<{ path: string; content: string; truncated: boolean }>> {
  const result: Array<{ path: string; content: string; truncated: boolean }> = [];
  for (const rel of files) {
    if (!isImportantPath(rel) || isSecretPath(rel)) continue;
    try {
      const absolute = join(workspaceRoot, rel);
      const content = await readFile(absolute, 'utf8');
      const truncated = content.length > maxCharsPerFile;
      result.push({
        path: relative(workspaceRoot, absolute).replace(/\\/g, '/'),
        content: truncated ? content.slice(0, maxCharsPerFile) + '\n...[truncated]' : content,
        truncated,
      });
    } catch {
      // Ignore unreadable files.
    }
  }
  return result;
}

